var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.916 7H13.416C12.4218 7.00119 11.4687 7.39666 10.7657 8.09966C10.0627 8.80267 9.66721 9.7558 9.66602 10.75V19H21.666V10.75C21.6648 9.7558 21.2694 8.80267 20.5664 8.09966C19.8633 7.39666 18.9102 7.00119 17.916 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 21.25C9.66721 22.2442 10.0627 23.1973 10.7657 23.9003C11.4687 24.6033 12.4218 24.9988 13.416 25H17.916C18.9102 24.9988 19.8633 24.6033 20.5664 23.9003C21.2694 23.1973 21.6648 22.2442 21.666 21.25V20.5H9.66602V21.25ZM15.666 22C15.8144 22 15.9594 22.044 16.0827 22.1264C16.206 22.2088 16.3022 22.3259 16.3589 22.463C16.4157 22.6 16.4305 22.7508 16.4016 22.8963C16.3727 23.0418 16.3012 23.1754 16.1963 23.2803C16.0915 23.3852 15.9578 23.4567 15.8123 23.4856C15.6668 23.5145 15.516 23.4997 15.379 23.4429C15.242 23.3861 15.1248 23.29 15.0424 23.1667C14.96 23.0433 14.916 22.8983 14.916 22.75C14.916 22.5511 14.995 22.3603 15.1357 22.2197C15.2763 22.079 15.4671 22 15.666 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.069b7ef6afd48ea58ec9b7580850165a.svg";
export { ForwardRef as ReactComponent };